<!-- Career Coach Section -->
<div class="row w-100 mt-5 mx-0 justify-content-center">
  <div class="col-12 col-md-7  mt-5 pt-5 pt-md-0 my-md-auto col-lg-8 my-auto px-5 order-1">
    <div class="title">
      {{ "Career Coach" | translate }}
    </div>
    <div class="description">
      {{
      "We help take your career to the next level with professional career coaching"
      | translate
      }}
    </div>
    <a href="https://wa.me/+201555842727" target="_blank">
      <button class="gradient-button">
        {{ "Schedule with your coach" | translate }}
      </button>
    </a>
  </div>
  <img class="col-6 col-md-5 col-lg-4 order-2  mt-5" src="../../../assets/img/career coatch.png" />
</div>

<!-- Services Section -->
<section class="services-section">
  <div class="container">
    <div class="row justify-content-center px-2 px-md-0">
      <!-- Title Card (replaces first card position) -->
      <div class="col-12 col-sm-6 col-md-4">
        <div class="title-card">
          <h3 class="services-main-title">
            {{ "Positive behavioral supports is a behavior management" | translate }}
          </h3>
          <p class="services-main-description">
            {{
            "Up-Career is everything you need to grow in your online career"
            | translate
            }}
          </p>
        </div>
      </div>

      <!-- Service Cards -->
      <app-card *ngFor="let item of services" [color]="item.color" [img]="item.img" [title]="item.title"
        [description]="item.description" />
    </div>
  </div>
</section>
<!-- <app-video-tutorial [title]="'careerCoachingVideo.videoTitle'"
  [videoPath]="'../../../assets/video/Recording 2025-11-25 203710.mp4'"
  [videoPoster]="'../../../assets/img/Frame 2095587743.png'" [buttonText]="'careerCoachingVideo.videoButton'"
  [buttonLink]="'https://wa.me/+201555842727'"></app-video-tutorial> -->

<app-certificates></app-certificates>
<app-pricing></app-pricing>

<!-- CV Builder Section -->
<section class="cv-section">
  <div class="container">
    <div class="text-center mb-5">
      <h2 class="titlle">{{ "cvSection.title" | translate }}</h2>
      <p class="subtitle mt-3">
        {{ "cvSection.subtitle" | translate }}
      </p>
    </div>
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-12 col-md-5 mb-4 mb-md-0 text-center">
        <img class="img-fluid " src="../../../assets/img/1014216_OJ8XXE1.png" alt="CV Image" />
      </div>
      <div class="col-12 col-md-7 px-md-5">
        <p class="title-bulid">{{ "cvSection.buildTitle" | translate }}</p>
        <p class="section-text">
          {{ "cvSection.buildDescription" | translate }}
        </p>
        <button class="gradient-button" routerLink="/generatResume">
          {{ "cvSection.buttonText" | translate }}
        </button>
      </div>
    </div>
  </div>
</section>